import { RootState } from 'reduxStore/types';

export const getProfileState = (state: RootState) => state?.profile;
